import React from 'react';
import { styled, Box } from '@goodrx/matisse';
import { SpaceProps } from 'styled-system';

const ListItem = styled(Box)`
  & > * {
    padding: 16px 8px;
  }

  & + & {
    border-top: 1px solid ${(p: any) => p.theme.colors.greyLight};
  }

  &:hover {
    background: ${(p: any) => p.theme.colors.greyLightest};
  }
`;

type ListProps<T> = {
  items: T[];
  render: (item: T) => JSX.Element;
  keyExtractor?: (item: T & { id?: string | number }) => string;
} & SpaceProps;

export const List: <T>(props: ListProps<T>) => JSX.Element = ({
  items,
  render,
  keyExtractor = (item) => `${item.id}`,
  ...props
}) => {
  return (
    <Box {...props}>
      {items.map((item) => (
        <ListItem alignItems="center" key={keyExtractor(item)}>
          {React.Children.only(render(item))}
        </ListItem>
      ))}
    </Box>
  );
};
